/**
 * Resolve the current numeric LiveComponent CID for a drawer input.
 *
 * CIDs are not stable across LiveView patches. Call this immediately before
 * `pushEventTo` instead of retaining the value captured when the hook mounted.
 */
export function liveComponentTarget(element) {
  const raw = element?.closest?.("[phx-target]")?.getAttribute?.("phx-target")

  if (typeof raw !== "string" || !/^\d+$/.test(raw)) return null

  const cid = Number(raw)
  return Number.isSafeInteger(cid) ? cid : null
}
